module.exports = __webpack_public_path__ + "static/die-trying-f3e730b84903225bafa3b70f9ba0f296.jpg";